import styles from "./footer.module.css";

export function AppFooter(): JSX.Element {
  const appVersion = process.env.REACT_APP_VERSION || "dev";

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <span className={styles.brand}>webtypist</span>
          <span className={styles.separator}>•</span>
          <span className={styles.muted}>train anywhere</span>
        </div>

        <div className={styles.right}>
          <span className={styles.kbd}>{appVersion}</span>
          <span className={styles.separator}>•</span>
          <span className={styles.muted}>
            built for focus
          </span>
        </div>
      </div>
    </footer>
  );
}